// import react from "react"

const Recipe = ({ image, name }) => {
  return (
    <div
      style={{
        backgroundImage: `url('${image}')`,
        width: "100%",
        height: 240,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column-reverse",
      }}
    >
      <div
        style={{ color: "white", padding: 16, backgroundColor: "#00000077" }}
      >
        {name}
      </div>
    </div>
  )
}

export default Recipe
